import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbInputModule,
} from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { StepUpOtpDialogComponent } from './step-up-otp-dialog.component';
import { StepUpOtpSetupDialogComponent } from './step-up-otp-setup-dialog.component';
import { StepUpMfaSetupRequiredDialogComponent } from './step-up-mfa-setup-required-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NbInputModule,
    NbButtonModule,
    NbIconModule,
  ],
  declarations: [
    StepUpOtpDialogComponent,
    StepUpOtpSetupDialogComponent,
    StepUpMfaSetupRequiredDialogComponent,
  ],
  exports: [
    StepUpOtpDialogComponent,
    StepUpOtpSetupDialogComponent,
    StepUpMfaSetupRequiredDialogComponent,
  ],
  entryComponents: [
    StepUpOtpDialogComponent,
    StepUpOtpSetupDialogComponent,
    StepUpMfaSetupRequiredDialogComponent,
  ],
})
export class StepUpOtpModule {}
